import { PropsWithChildren } from 'react';
import { theme } from '@frontend/theme';

export const ListsCenteredContainer = ({ children }: PropsWithChildren) => (
  <div
    css={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: `calc(100% - ${theme.spacing(9)})`,
      flexDirection: 'column',
    }}
  >
    {children}
  </div>
);
